import { action } from 'typesafe-actions';
import { IGetPayPeriodsOptions, IGetPayPeriodsSuccessParams } from 'types';
import { PayPeriods } from './types';

export const getPayPeriodsRequest = (options: IGetPayPeriodsOptions) => action(PayPeriods.GET_PAY_PERIODS_REQUEST, options);
export const getPayPeriodsSuccess = (response: IGetPayPeriodsSuccessParams) => action(PayPeriods.GET_PAY_PERIODS_SUCCESS, response);
export const getPayPeriodsError = (error: any) => action(PayPeriods.GET_PAY_PERIODS_FAIL, error);
